import { render, staticRenderFns } from "./ShowInformation.vue?vue&type=template&id=fd3c6466&"
import script from "./ShowInformation.vue?vue&type=script&lang=js&"
export * from "./ShowInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports